module.exports = __webpack_public_path__ + "static/img/monitior1.1cbbf5cb.png";